import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { MonthPickerProps } from '../interface/interface';
import moment from 'moment';

export default function CustomMonthDatePicker({
  monthRange,
  onMonthChange,
  restrict,
}: Readonly<MonthPickerProps>) {
  const [startDate, endDate] = monthRange;

  const minDate = moment().subtract(restrict, 'months').toDate();
  const maxDate = moment().toDate();

  const handleDateChange = (monthRange: [Date | null, Date | null]) => {
    onMonthChange(monthRange);
  };

  return (
    <div>
      <DatePicker
        selected={startDate}
        onChange={handleDateChange}
        startDate={startDate}
        endDate={endDate}
        selectsRange
        dateFormat="MMM yyyy"
        showMonthYearPicker
        placeholderText="Select a month range"
        className="w-[180px] px-4 py-2 border border-primary-blue-500 
        rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm cursor-pointer"
        minDate={minDate}
        maxDate={maxDate}
      />
    </div>
  );
}
